export const AVATAR_SIZE_SMALL = 24;
export const AVATAR_SIZE_MEDIUM = 32;
export const AVATAR_SIZE_LARGE = 40;

export const AVATAR_STATUS_ONLINE = 'online';
export const AVATAR_STATUS_OFFLINE = 'offline';
export const AVATAR_STATUS_AWAY = 'away';

export type AvatarStatus =
  | typeof AVATAR_STATUS_ONLINE
  | typeof AVATAR_STATUS_OFFLINE
  | typeof AVATAR_STATUS_AWAY;
